import { Component, OnInit } from '@angular/core';
import { FundosServices } from 'src/app/services/fundos.service';
import { FormGroup, FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-funds',
    templateUrl: './funds.component.html',
    styleUrls: ['./funds.component.css'],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxPaginationModule]
})
export class FundsComponent implements OnInit {

  public fundos:any[] = [];
  public anoMesInicio:any[] = [];
  public anoMesFim:any[] = [];
  public tiposFundos:any[] = [];
  public formFiltro: FormGroup = null;
  paginaAtual : number = 1 ;
  qntPorPage : number = 10;


  constructor(private fundosService:FundosServices) {

    this.formFiltro = new FormGroup({
      anomesInicio:new FormControl(0),
      anomesFim: new FormControl(0),
      tipoFundo: new FormControl(0),
      tipoOrdem: new FormControl(0),
    });
    
   }

  ngOnInit() {
    this.buscarFiltros();
    this.ListarTiposFundo();
    this.Listar();
  }


  public buscarFiltros(){
    this.fundosService.buscaFiltros()
    .subscribe(
      (res:any)=>{
        this.anoMesFim = res.anomesFim;
        this.anoMesInicio = res.anomesInicio;
      }
    )
  }

  public ListarTiposFundo(){
    this.fundosService.ListaTiposFundo()
    .subscribe(
      (res:any)=>{
        this.tiposFundos = res;
      }
    )
  }

  public Listar(){
    this.paginaAtual = 1;
    let anomesInicio = this.formFiltro.get("anomesInicio").value;
    let anomesFim = this.formFiltro.get("anomesFim").value;
    let tipoFundo = this.formFiltro.get("tipoFundo").value;
    let tipoOrdem = this.formFiltro.get("tipoOrdem").value;

    this.fundosService.Listar(anomesInicio,anomesFim,tipoFundo,tipoOrdem)
    .subscribe(
      (res:any)=>{
        this.fundos = res;
      }
    )
  }

  print() {
    window.print();
  }

}
